let MANAGE_API = '/api/manage'
export let MANAGE_EVENT_API = `${MANAGE_API}/event`

export let MANAGE_EVENTS_API = `${MANAGE_API}/events`
export let MANAGE_EVENT_INSTRUCTORS_API = `${MANAGE_EVENT_API}/instructors`
export let MANAGE_EVENT_CATEGORIES_API = `${MANAGE_EVENT_API}/categories`
export let MANAGE_EVENT_ACCREDITATIONS_API = `${MANAGE_EVENT_API}/accreditations`
export let MANAGE_EVENT_ACCREDITATION_JOINS_API = `${MANAGE_EVENT_API}/accreditations/joins`
export let MANAGE_EVENT_TEMPLATES_API = `${MANAGE_API}/templates`
export let MANAGE_EVENT_TEMPLATE_JOINS_API = `${MANAGE_API}/template/event/joins`
export let MANAGE_EVENT_SESSION_BASE_API = `${MANAGE_EVENT_API}/session`

export let MANAGE_EVENT_INVITE_BASE_API = `${MANAGE_EVENT_API}/invite`

export let EVENT_COLOR_VIRTUAL = '#6694e9'
export let EVENT_COLOR_IN_PERSON = '#02B2AF'
export let EVENT_COLOR_HYBRID = '#B39DDB'

export let LICENSE_TYPE_COLORS: Record<string, string> = {
  EMT: '#72CCFF',
  AEMT: '#02B2AF',
  Paramedic: '#B39DDB',
  'Registered Nurse': '#FFE082',
  Other: '#B0BEC5',
}
